import moment from "moment";

//table layout
export const tableStyle = (row, rowIndex, cell) => {	
	const style = {};
	if (rowIndex % 2 === 0) {
		style.backgroundColor = "#E5F7F6";
	} else {
		style.backgroundColor = " #F2FBFA";
	}
	if (row) {
		style.color = "#43A3A5";
	}

	if(row.isApprovedCompensationLog==true){
	
		style.backgroundColor = "rgb(300, 232, 232)";
	}
	return style;
};
//-----------
//Date Column
export const dateCol = (cell) => {
	let dateObj = cell;
	if (cell !== "date") {
		dateObj = new Date(cell);
	}
	return `${("0" + dateObj.getDate()).slice(-2)}/${(
		"0" +
		(dateObj.getMonth() + 1)
	).slice(-2)}/${dateObj.getFullYear()}`;
};
//--------
//Time Column
export const timeCol = (cell) => {
	return `${moment(cell, "hh mm").format("LT")}`;
};
//--------
//Status Colors
export const statusColor = (status) => {
	switch (status) {
		case "Pending":
		case "InProgress":
		case "Draft":
		case "In Progress":
		case "Item Inspected":
		case "Item Tagged":
		case "Item Verified":
		case "Item Received":
		case "At Official Visit":
			return { color: "#ffbe5c" };
		case "Approved":
		case "Approve":
		case "PM Approved":
		case "CM Approved":
		case "Admin/Support Approved":
		case "Completed":
		case "Active":
			return { color: "#61b1b3" };
		case "Rejected":
		case "Reject":
		case "Not Created":
		case "Deferred":
		case "Admin/Support Rejected":
		case "PM Rejected":
		case "Inactive":
			return { color: "tomato" };
		default:
			return { color: "#61b1b3" };
	}
};

//-----------
//Trim String
export const TrimString = (cell) => {
	if (cell != null)
		if (cell.length > 20) return cell.substring(0, 20) + "...";
		else return cell;
};
//-----------
//Trim String
export const LongTrimString = (cell) => {
	if (cell != null)
		if (cell.length > 30) return cell.substring(0, 30) + "...";
		else return cell;
};
export const dividelines = (cell) => {
	if (cell != null)
		if (cell.length > 20) return cell.split("\n");
		else return cell;
};
